module.exports = __webpack_public_path__ + "media/images/sample/banner-sm-bb5a78cc0e06567fda16040c9d10125f.png";